import React, { useState } from 'react';
import { compose } from 'redux';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import {
  H2,
  Form,
  Page,
  Button,
  IconSort,
  IconSearch,
  ModalInMobile,
  FieldTextInput,
  PaginationLinks,
  LayoutSingleColumn,
  InlineTextButton,
  Modal,
  H3,
  IconCup,
  PrimaryButton,
  NamedLink,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { CreateTenderForm } from './CreateTenderForm/CreateTenderForm';
import {
  createTender,
  getTransactionsByListingId,
} from './TendersPage.duck';
import { Tender } from './Tender';
import { parse } from '../../util/urlHelpers';
import { routeConfiguration } from '../../index';
import { dateToTimestamp } from '../../util/dates';
import FilterComponent from '../SearchPage/FilterComponent';
import { createResourceLocatorString } from '../../util/routes';
import { useConfiguration } from '../../context/configurationContext';
import SearchFiltersPrimary from '../SearchPage/SearchFiltersPrimary/SearchFiltersPrimary';

import css from './TendersPage.module.css';
import {
  EQUIPMENT_PROCUREMENT,
  EQUIPMENT_PROVIDER,
  INDIVIDUAL,
  NO_SUBSCRIPTION_PLAN,
  SUBSCRIPTION_PLAN_BUSINESS,
  SUBSCRIPTION_PLAN_PREMIER,
} from '../../constants';

const LISTING_TYPE_TENDER = 'tender';
const STATUS_OPEN = 'open';

const MODAL_BREAKPOINT = 1024;

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

const submit = () => {};

const FieldSearch = props => {
  const { id, name, intl, onChange, label, className } = props;

  const placeholder = intl.formatMessage({ id: 'TendersPage.searchInputPlaceholder' });

  return (
    <FinalForm
      {...props}
      render={fieldRenderProps => {
        const { handleSubmit } = fieldRenderProps;

        return (
          <Form onSubmit={handleSubmit}>
            <FormSpy onChange={onChange} subscription={{ values: true }} />
            <div className={classNames(css.searchInputContainer, className)}>
              <IconSearch className={css.searchIcon} />
              <FieldTextInput
                id={id}
                name={name}
                label={label}
                className={css.searchInput}
                placeholder={placeholder}
              />
            </div>
          </Form>
        );
      }}
    />
  );
};

export const TendersPageComponent = props => {
  const {
    intl,
    currentUser,
    onCreateTender,
    scrollingDisabled,
    onManageDisableScrolling,
    createTenderInProgress,
    tenders,
    pagination,
    adminProfile,
    history,
    location,
    onGetTransactionsByListingId,
  } = props;

  const [sort, setSort] = useState('createdAt');
  const [isOpen, setIsOpen] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [isOpenMobile, setIsOpenMobile] = useState(false);
  const [isOpenRestrictModal, setIsOpenRestrictModal] = useState(false);

  const config = useConfiguration();
  const listingFields = config?.listing?.tenderFields;

  const isCPO = currentUser?.attributes?.profile?.privateData?.isCPO;
  const { Subscription_plan = NO_SUBSCRIPTION_PLAN } =
    currentUser?.attributes?.profile?.privateData ?? {};
  const { accountBusinessType, accountType } = currentUser?.attributes?.profile?.publicData ?? {};

  const isIndividual = accountType === INDIVIDUAL;
  const noSubscription = Subscription_plan === NO_SUBSCRIPTION_PLAN;
  const isBusinessSubscription = Subscription_plan === SUBSCRIPTION_PLAN_BUSINESS;
  const isPremierSubscription = Subscription_plan === SUBSCRIPTION_PLAN_PREMIER;
  const isBusinessEquipmentProcurement = accountBusinessType === EQUIPMENT_PROCUREMENT;
  const isBusinessEquipmentProvider = accountBusinessType === EQUIPMENT_PROVIDER;

  const showNoSubscriptionButton = isBusinessEquipmentProvider && noSubscription;
  const showPartialSubscriptionButton =
    isBusinessEquipmentProvider && (isBusinessSubscription || isPremierSubscription);

  const { referenceNumber } = adminProfile?.attributes?.profile?.publicData ?? {};

  const title = intl.formatMessage({ id: 'TendersPage.title' });

  const topBar = <TopbarContainer currentPage="TendersPage" />;

  const onChangeModalState = state => setIsOpen(state);
  const onChangePreviewState = state => setIsPreview(state);
  const onChangeMobileModalState = state => setIsOpenMobile(state);
  const onChangeRestrictModalState = state => setIsOpenRestrictModal(state);

  const onPostTender = values => {
    const {
      tenderReferenceName,
      tenderDates,
      submissionDeadline,
      location: projectLocation,
      ...rest
    } = values;
    const {
      selectedPlace: { origin },
    } = projectLocation ?? {};

    const tenderDatesStart = dateToTimestamp(tenderDates?.startDate);
    const tenderDatesEnd = dateToTimestamp(tenderDates?.endDate);
    const submissionDeadlineDate = dateToTimestamp(submissionDeadline?.date);

    const params = {
      title: tenderReferenceName,
      geolocation: origin,
      publicData: {
        listingType: LISTING_TYPE_TENDER,
        location: projectLocation,
        tenderDatesStart,
        tenderDatesEnd,
        submissionDeadlineDate,
        tenderStatus: STATUS_OPEN,
        ...rest,
      },
    };

    onCreateTender(params, referenceNumber + 1).then(() => history.go(0));
  };

  const validUrlQueryParams = parse(location?.search);

  const onChangeSort = () => {
    const sortParams = sort === 'createdAt' ? '-createdAt' : 'createdAt';
    const params = createResourceLocatorString(
      'TendersPage',
      routeConfiguration(),
      null,
      { ...validUrlQueryParams, page: 1, sort: sortParams },
      '#search'
    );
    history.push(params);
    setSort(sortParams);
  };

  const onGetHandleChangedValueFn = () => values => {
    const params = createResourceLocatorString(
      'TendersPage',
      routeConfiguration(),
      null,
      { ...validUrlQueryParams, page: 1, ...values },
      '#search'
    );

    history.push(params);
  };

  const onChangeSearch = values => {
    const params = createResourceLocatorString(
      'TendersPage',
      routeConfiguration(),
      null,
      { ...validUrlQueryParams, page: 1, keywords: values?.values?.keywords },
      '#search'
    );

    history.push(params);
  };

  const applyFiltersMobile = () => {
    const params = createResourceLocatorString(
      'TendersPage',
      routeConfiguration(),
      null,
      validUrlQueryParams,
      '#search'
    );

    history.push(params);
    onChangeMobileModalState(false);
  };

  const debouncedFunction = debounce(onChangeSearch, 500); // Debounce delay (in milliseconds) as needed

  const onChangeKeywords = data => {
    if (!data?.values?.keywords || data?.values?.keywords?.length >= 3) {
      debouncedFunction(data);
    }
  };

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn className={css.pageRoot} topbar={topBar} footer={<FooterContainer />}>
        <div className={css.root}>
          <section className={css.bannerWrapper}>
            <div className={css.banner}>
              <H2 as="h1">
                <FormattedMessage id="TendersPage.bannerTitle" />
              </H2>
            </div>
          </section>
          <section className={css.contentWrapper}>
            <div className={css.content}>
              <section className={css.actionsSection} id="search">
                <div
                  className={classNames(css.sortBtn, css.filterMobileBtn)}
                  onClick={() => onChangeMobileModalState(true)}
                >
                  <FormattedMessage id="SearchFiltersMobile.filtersButtonLabel" />
                </div>

                <div
                  className={classNames(css.sortBtn, {
                    [css.sortButtonActive]: sort === '-createdAt',
                  })}
                  onClick={onChangeSort}
                >
                  <IconSort
                    type={sort === '-createdAt' ? 'secondary' : 'primary'}
                    direction={sort === 'createdAt' ? 'down' : 'up'}
                  />
                  <FormattedMessage id="SortBy.addedOn" />
                </div>
                <SearchFiltersPrimary rootClassName={classNames(css.mobile, css.filterContainer)}>
                  {listingFields.map(config => {
                    return (
                      <FilterComponent
                        key={`SearchFiltersPrimary.${config.key}`}
                        idPrefix="SearchFiltersPrimary"
                        config={config}
                        marketplaceCurrency={'EUR'}
                        urlQueryParams={validUrlQueryParams}
                        getHandleChangedValueFn={onGetHandleChangedValueFn}
                        initialValues={() => validUrlQueryParams || {}}
                        intl={intl}
                        showAsPopup
                      />
                    );
                  })}
                </SearchFiltersPrimary>
                <FieldSearch
                  id="keywords"
                  name="keywords"
                  className={css.mobile}
                  onSubmit={submit}
                  onChange={onChangeKeywords}
                  intl={intl}
                />
                {isCPO ? (
                  <InlineTextButton
                    className={css.attachmentBtn}
                    onClick={() => {
                      onChangeModalState(true);
                    }}
                  >
                    <FormattedMessage id="TendersPage.createTenderButton" />
                  </InlineTextButton>
                ) : (
                  <InlineTextButton
                    className={css.attachmentBtn}
                    onClick={() => history.push('/p/tender-submissions')}
                  >
                    <FormattedMessage id="TendersPage.createTenderButton" />
                  </InlineTextButton>
                )}
              </section>
              <div className={css.tendersContainer}>
                {tenders?.length ? (
                  tenders.map(tender => (
                    <Tender
                      listing={tender}
                      history={history}
                      onChangeRestrictModalState={onChangeRestrictModalState}
                      showNoSubscriptionButton={showNoSubscriptionButton}
                      showPartialSubscriptionButton={showPartialSubscriptionButton}
                      onGetTransactionsByListingId={onGetTransactionsByListingId}
                    />
                  ))
                ) : (
                  <div className={css.noResultMessage}>
                    <FormattedMessage id="TendersPage.noResults" />
                  </div>
                )}
              </div>
              {!!pagination && pagination.totalPages > 1 && (
                <PaginationLinks
                  className={css.pagination}
                  pageName="TendersPage"
                  pageSearchParams={validUrlQueryParams}
                  pagination={pagination}
                />
              )}
            </div>
          </section>
        </div>
        <CreateTenderForm
          onSubmit={onPostTender}
          isOpen={isOpen}
          onManageDisableScrolling={onManageDisableScrolling}
          intl={intl}
          onChangeModalState={onChangeModalState}
          isPreview={isPreview}
          onChangePreviewState={onChangePreviewState}
          createTenderInProgress={createTenderInProgress}
          initialValues={{ tenderReferenceName: `HC${referenceNumber + 1}` }}
        />
        <ModalInMobile
          id={'TendersPage'}
          containerClassName={css.modalContainer}
          onClose={() => onChangeMobileModalState(false)}
          isModalOpenOnMobile={isOpenMobile}
          onManageDisableScrolling={onManageDisableScrolling}
          showAsModalMaxWidth={MODAL_BREAKPOINT}
          usePortal
        >
          <div className={css.modalContentContainer}>
            <label htmlFor="keyword" className={css.keywordLabel}>
              <FormattedMessage id="CreateTenderForm.tenderReferenceNameLabel" />
            </label>
            <FieldSearch
              id="keywords"
              name="keywords"
              onSubmit={submit}
              onChange={onChangeKeywords}
              intl={intl}
            />
            <SearchFiltersPrimary>
              {listingFields.map(config => {
                return (
                  <FilterComponent
                    key={`SearchFiltersPrimary.${config.key}`}
                    idPrefix="SearchFiltersPrimary"
                    config={config}
                    marketplaceCurrency={'EUR'}
                    urlQueryParams={validUrlQueryParams}
                    getHandleChangedValueFn={onGetHandleChangedValueFn}
                    initialValues={() => validUrlQueryParams || {}}
                    intl={intl}
                    liveEdit
                    showAsPopup={false}
                  />
                );
              })}
            </SearchFiltersPrimary>
            <Button onClick={applyFiltersMobile}>
              <FormattedMessage id="TendersPage.showTendersBtn" />
            </Button>
          </div>
        </ModalInMobile>
        <Modal
          id="AccessRestricted"
          usePortal
          isOpen={isOpenRestrictModal}
          containerClassName={css.restrictModalContainer}
          onClose={() => onChangeRestrictModalState(false)}
          onManageDisableScrolling={onManageDisableScrolling}
          closeButtonMessage={' '}
        >
          <div className={css.restrictModalContent}>
            <H3 as="h1" className={css.heading}>
              <FormattedMessage id="TendersPage.accessModalTitle" />
            </H3>
            <div>
              <IconCup />
            </div>
            <p className={css.restrictModalText}>
              <FormattedMessage
                id={
                  showNoSubscriptionButton
                    ? 'TendersPage.noSubscriptionModalMessage'
                    : 'TendersPage.partialSubscriptionModalMessage'
                }
              />
            </p>

            {!showNoSubscriptionButton ? (
              <NamedLink name="SubscriptionPage" className={css.upgradeButtonLink}>
                <FormattedMessage id='TendersPage.partialSubscriptionModalButton'/>
              </NamedLink> ) : (
                <PrimaryButton>
                  <a href={config?.calendarLink} className={css.upgradeButtonLink} target="_blank">
                    <FormattedMessage
                      id='TendersPage.noSubscriptionModalButton'
                    />
                  </a>
                </PrimaryButton>
             )}
          </div>
        </Modal>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    tenders,
    createTenderInProgress,
    pagination,
    adminProfile,
    getAdminProfileInProgress,
    getAdminProfileError,
  } = state.TendersPage;

  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    createTenderInProgress,
    tenders,
    pagination,
    adminProfile,
    getAdminProfileInProgress,
    getAdminProfileError,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onCreateTender: (data, refNumber) => dispatch(createTender(data, refNumber)),
  onGetTransactionsByListingId: (id) => dispatch(getTransactionsByListingId(id))
});

const TendersPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(TendersPageComponent);

export default TendersPage;
